import CobranzaCreate from './CobranzaCreate'
export {CobranzaCreate}
export default CobranzaCreate
